import React from "react";
import { motion } from "framer-motion";

interface ProgramOptionProps {
    title: string;
    description: string;
}

const ProgramOption: React.FC<ProgramOptionProps> = ({ title, description }) => {
    return (
        <motion.article className="flex flex-col text-white max-md:mt-8"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
        >
            <h3 className="self-start text-3xl font-bold leading-tight">
                {title}
            </h3>
            <p className="mt-8 text-sm leading-5 text-justify">
                {description}
            </p>
        </motion.article>
    );
};

export default ProgramOption;
